import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	CircularProgress,
	Avatar,
	Button,
	CssBaseline,
	FormControl,
	Input,
	InputLabel,
	Paper,
	Typography,
	Divider, InputAdornment, IconButton, Link, Grid
} from '@material-ui/core';
import { VisibilityOff, Visibility } from '@material-ui/icons';
import { Fade } from 'react-reveal';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import withStyles from '@material-ui/core/styles/withStyles';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import queryString from 'query-string'
import * as actions from '../../store/actions';
import * as memberAction from '../../store/actions/members';
import URLDialog from '../common/URLDialog';
import { TermsAndConditions, PrivacyPolicy } from './../Constants';
import IcareLogo from "./../../assets/images/icare_logo_transparent.png";

// const termsConditions = "https://www.icarehealthplan.org/terms";
// const privacyPolicy = "https://www.icarehealthplan.org/Utility-Navigation/Privacy-Policy.htm";

const styles = theme => ({
	root: {
		marginTop: theme.spacing(1) * 8,
		textAlign: 'center'
	},
	main: {
		width: 'auto',
		display: 'block', // Fix IE 11 issue.
		marginLeft: theme.spacing(3),
		marginRight: theme.spacing(3),
		[theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
			width: 400,
			marginLeft: 'auto',
			marginRight: 'auto'
		}
	},
	paper: {
		marginTop: theme.spacing(2),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${theme.spacing(1) * 2}px ${theme.spacing(1) * 3}px ${theme.spacing(1) * 3}px`
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1)
	},
	submit: {
		marginTop: theme.spacing(1) * 6
	},
	buttons2: {
		margin: theme.spacing(1) * 2,
		width: '100%',
		justifyContent: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start'
	},
	error: {
		backgroundColor: '#f2f0f0',
		marginTop: '10px',
		borderStyle: 'solid',
		borderColor: '#ab2109',
		borderWidth: '2px 2px 2px 5px',
		borderRadius: '5px',
		width: '100%',
		padding: '10px'
	},
	errorText: {
		color: theme.palette.error
	}
});

class LoginPage extends Component {
	state = {
		username: '',
		password: '',
		loginParams: '',
		showPassword: false,
		queryParams: {},
		formRefresh: false
	};

	componentDidMount = () => {
		if (this.props.location.search) {
			let queryParams = queryString.parse(this.props.location.search);
			if (queryParams && queryParams.client_id && queryParams.redirect_uri && queryParams.response_type && queryParams.state) {
				this.props.dispatch(memberAction.memberLoginRedirect(queryParams, () => {
					this.setState({ queryParams: queryParams });
				}));
			} else {
				console.log("Incomplete or No params, showing login");
			}
		}
	}

	handleChange = name => event => {
		if (this.props.url) {
			this.props.dispatch(memberAction.resetURL());
		}
		this.setState({
			[name]: event.target.value,
			loginParams: window.location.search.substring(1) ,
			formRefresh: true
		});
		this.props.dispatch(actions.loginFormChanged());
	};

	onClickLogin = () => {
		const { username, password } = this.state;
		let params = this.state.queryParams;
		params.userId = username;
		params.password = password;
		params.requestId = this.props.requestId;
		this.props.dispatch(memberAction.memberAuthentication(params, (url) => {
			this.setState({ formRefresh: false });
		}));
	};

	onRegister = () => {
		this.props.history.push('/register');
	}

	onForgetPassword = () => {
		this.props.history.push('/forgot');
	}
    handleShow = () => {
        this.setState({ showPassword: !this.state.showPassword })
    }
	render() {
		const { classes, handleSubmit, loginErrorMsg, loading, url } = this.props;
		const { formRefresh } = this.state;
		const { root, main, paper, avatar, form } = classes;

		// let loginErrorMsg2 = loginErrorMsg;
		let isLoginError = undefined;

		if (url) {
			const qs2 = url.substring(url.indexOf("?"));
			let params = new URLSearchParams(qs2);
			isLoginError = params.get("error");
		}

		if (url && !isLoginError) {
			window.location.href = url;
			return null;
		} else {
			return (
				<div className={root}>
					<img src={IcareLogo} alt="Icare" height="135px"/>
				<main className={main}>
					<CssBaseline />
					<Paper className={paper}>
						<Avatar className={avatar}>
							<LockOutlinedIcon />
						</Avatar>
						<Typography component='h1' variant='h5'>
							Login
						</Typography>

						{ loginErrorMsg &&
							<div className={classes.error}>
								<Fade bottom>
									<Typography variant='body2' color='error' align='left'>
										{loginErrorMsg}
									</Typography>
								</Fade>
							</div>
						}
						
						<form
							className={form}
							onSubmit={handleSubmit(this.onClickLogin)}
						>
							<FormControl margin='normal' required fullWidth>
								<InputLabel htmlFor='loginID'>Login ID</InputLabel>
								<Input
									id='loginID'
									name='loginID'
									autoComplete='loginID'
									autoFocus
									onChange={this.handleChange('username')}
									value={this.state.username}
								/>
							</FormControl>
							<FormControl margin='normal' required fullWidth>
								<InputLabel htmlFor='password'>Password</InputLabel>
								<Input
									name='password'
									type= { this.state.showPassword ? 'text' : 'password' }
									id='password'
									autoComplete='current-password'
									onChange={this.handleChange('password')}
									value={this.state.password}
									endAdornment= {
										<InputAdornment position='end'>
											<IconButton onClick={this.handleShow}>
												{this.state.showPassword  ? <Visibility /> : <VisibilityOff /> }
											</IconButton>
										</InputAdornment>
									}
										
								/>
								{/* <VisibilityOff/> */}
							</FormControl>
							
							<Button
								type='submit'
								fullWidth
								variant='contained'
								color='primary'
								className={classes.submit}
								disabled={loading}
							>
								Sign in
								<span style={{ paddingLeft: '20px' }}>
									{loading && (
										<CircularProgress size={16} thickness={2} color='inherit' />
									)}
								</span>
							</Button>
						</form>
						<Divider variant={"fullWidth"} style={{ marginTop: "20px", marginBottom: "20px", width: "100%" }}/>
						<div className={classes.buttons2}>
							<Typography variant='body2' color='textSecondary' style={{ paddingLeft: "8px" }}>
								Having issues with login, forgot Password/Login Id
							</Typography>
							<Button color='primary' onClick={this.onForgetPassword}>Trouble Logging in? </Button>
	
							<Typography variant='body2' color='textSecondary' style={{ paddingLeft: "8px" }}>
								Do not have an account to manage your healthcare
							</Typography>
							<Button color='primary' onClick={this.onRegister}>
								Register
							</Button>
						</div>
						<div className={classes.buttons2}>
						{/* <Grid container justify="space-between" alignItems="space-between">
                            <Link href="https://www.icarehealthplan.org/terms" >Terms & Conditions</Link>
							<Link href="https://www.icarehealthplan.org/Utility-Navigation/Privacy-Policy.htm" >Privacy Policy</Link>
                        </Grid> */}
						<Grid container justify="space-between" alignItems="space-between">
							<URLDialog linkName= "Terms & Conditions" urlLink={TermsAndConditions} />
							<URLDialog linkName= "Privacy Policy" urlLink={PrivacyPolicy}/>
                        </Grid>

						</div>
					</Paper>
				</main>
				</div>
			);
		}

		
	}
}

LoginPage.propTypes = {
	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired
};

const mapDispatchToProps = state => {
	return { 
		requestId: state.members && state.members.requestId,
		redirectURL: state.members && state.members.redirectURL,
		loginErrorMsg: state.members && state.members.loginErrorMsg,
		loading: state.members && state.members.loading,
		url: state.members && state.members.url
	 };
};

export default compose(
	connect(
		mapDispatchToProps,
		actions
	),
	reduxForm({ form: 'loginForm1' }),
	withStyles(styles, { withTheme: true })
)(LoginPage);
